import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { showValidation } from "./utilities/showValidation";
import { showLabel } from "./utilities/showLabel";

const DateTimePickerField = (props) => {
  let { formId, field } = props;
  let { element } = field;
  const handleRawChange = (event) => {
    const allowKeyboardInput = element.settings[element.type].allowKeyboardInput;
    const inputValue = event.target.value;
    const format = element.settings[element.type].format;
    const interval = element.settings[element.type].timeIntervals;

    if (!event && !allowKeyboardInput) return;

    const normalizeTime = (value) =>
      value.replace(/\b(\d):(\d)\b/g, "0$1:0$2")
        .replace(/\b(\d{1}):(\d{2})\b/g, "0$1:$2")
        .replace(/\b(\d{2}):(\d{1})\b/g, "$1:0$2");

    const normalized = normalizeTime(inputValue);

    const parsed = moment(normalized, format, true);

    if (!parsed.isValid()) {
      console.warn("Invalid date format");
      return;
    }

    const minutes = parsed.minutes();
    if (interval && minutes % interval !== 0) {
      console.warn("Time does not match interval");
      return;
    }

    props.changeHandler({ target: { value: parsed.toDate() } }, false);
  };


  return (
    <div className="field-style">
      {showLabel(field, formId)}
      <DatePicker
        placeholderText={element.placeholder.visible ? element.placeholder.value.toUpperCase() : ""}
        id={formId + "_" + field.id}
        name={formId + "_" + field.id}
        selected={element.value && Date.parse(element.value) ? moment(element.value) : null}
        disabled={element.disabled}
        onChange={(date) => {
          props.changeHandler({ target: { value: date } }, false);
        }}
        dateFormat={element.settings[element.type].format}
        timeFormat={element.settings[element.type].timeFormat}
        minDate={element.settings[element.type].minDate}
        maxDate={element.settings[element.type].maxDate}
        showTimeSelect={element.settings[element.type].showTimeInput ? false : true}
        showTimeInput={element.settings[element.type].showTimeInput ? true : false}
        timeIntervals={element.settings[element.type].timeIntervals}
        showMonthDropdown={element.settings[element.type].showYearMonthControls}
        showYearDropdown={element.settings[element.type].showYearMonthControls}
        onChangeRaw={handleRawChange}
      />
      {showValidation(field)}
    </div>
  );
};

export default DateTimePickerField;



// WEBPACK FOOTER //
// ./src/libraries/form/formField/fields/DateTimePickerField.jsx